import { MBIconV2Name } from '@shared/components/image';
import { isRelatedCardLookupComponent } from '../../utils';
import { FieldOption } from './FieldOption';

export class RelatedCardLookupFieldOption implements FieldOption {
  constructor(
    readonly title: string,
    readonly icon: MBIconV2Name,
    readonly component: Partial<MBAPI.WorkflowTemplate_components_RelatedCardLookupComponent>,
  ) {}

  matchesComponent(
    component: MBAPI.WorkflowTemplate_components,
    _reservedIds: Array<string>,
  ): boolean {
    return isRelatedCardLookupComponent(component);
  }

  canBeAdded(_components: MBAPI.WorkflowTemplate_components[]): boolean {
    return true;
  }
}
